import React, { useEffect } from 'react';
import { ErrorState } from '../../../components/states';
import PoliticsForm from '../../../components/forms/PoliticsForm';
import Loader from '../../../components/Loader';
import { useFetch } from '../../../hooks/useFetch';

export default function PoliticsPage() {
  const { requestApi, data, error } = useFetch(`/v1/settings`);

  useEffect(() => {
    requestApi('get');
  }, []);

  if (error) {
    return <ErrorState onRetry={() => requestApi('get')} />;
  }

  return data?.data ? <PoliticsForm defaultValues={data?.data} /> : <Loader />;
}
